import { ReactNode, useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import useInterval from "../../../hooks/useInterval";
import { ReviewPriority } from "../../../models/ecg.interface";
import CircleIndicator from "../CircleIndicator/CircleIndicator";

import styles from "./ReviewPriorityIndicator.module.css";

type ReviewPriorityIndicatorProps = {
  priority: ReviewPriority;
  showTimeSymbol?: boolean;
  minutesRemaining?: number;
};

const ReviewPriorityIndicator = ({
  priority = "none",
  showTimeSymbol,
  minutesRemaining = 0,
}: ReviewPriorityIndicatorProps) => {
  const [runInterval, setRunInterval] = useState(
    priority !== "none" && minutesRemaining > 10
  );
  const [priorityState, setPriorityState] = useState<ReviewPriority>(priority);
  const [minutes, setMinutes] = useState<number>(minutesRemaining ?? 0);

  useInterval(
    () => {
      setMinutes((prev) => prev - 1);
    },
    // 1 minute delay or null to stop it
    runInterval ? 60000 : null
  );

  useEffect(() => {
    if (!minutes) {
      return;
    }

    if (minutes <= 10) {
      setRunInterval(false);
      setPriorityState("high");
    }
  }, [minutes]);

  let timeSymbol: ReactNode = null;
  if (showTimeSymbol) {
    switch (priority) {
      case "high":
        timeSymbol = "< 10";
        break;
      case "low":
        timeSymbol = "> 10";
        break;
      default:
        timeSymbol = (
          <FormattedMessage
            id="USER.ECG.REVIEW_PRIORITY.UNDEFINED"
            defaultMessage="Undefined"
          />
        );
        break;
    }
  }

  return (
    <div className="d-flex align-items-center">
      <CircleIndicator className={styles[priorityState]}>
        {priorityState === "high" ? (
          <span className="font-md">&#33;</span>
        ) : null}
      </CircleIndicator>
      {showTimeSymbol && <span className="font-md mx-1">{timeSymbol}</span>}
    </div>
  );
};
export default ReviewPriorityIndicator;
